// extracted by mini-css-extract-plugin
module.exports = {"installment-container":"styles_installment-container__eR3nu","installmentContainer":"styles_installment-container__eR3nu"};